import { max } from 'date-fns';
import WIDGETS from './widgets';

export default {
	name: 'admin_scheduler_form',
	spacing: 2,
	sx: { maxWidth: 'lg', justifySelf: 'center' },
	widgets: [{ content: WIDGETS.SCHEDULER_FORM, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
